import {
  ObjectTypeInfo,
  ObjectTypeInfoColumn,
  Query,
  QueryColumnSortOrder,
  SubQueryKind,
} from '@barthauer/abc/core/data';
import { ParameterDefinition } from '@barthauer/abc/queries/parameters/core';

export class DataConfig {
  currentObjectTypesList: ObjectTypeInfo[];
  currentObjectType: ObjectTypeInfo;
  currentObjectTypeColumns: ObjectTypeInfoColumn[];
  currentColumn: ObjectTypeInfoColumn;
}

export class ObjectTypeViewModel {
  objectTypeName: string;
  objectTypeAlias?: string;
  objectType: ObjectTypeInfo;

  selectedColumns: ObjectTypeInfoColumn[];
  skippedRowNumber?: number;
  limitedRowNumber?: number;
  isDuplicates?: boolean;
  constructor() {
    this.selectedColumns = [];
  }
}

export class Property {
  expression: string;
  name: string;
  alias: string;
  queryProperties?: QueryProperties;
  columnProperties?: ColumnProperties;
}

export class QueryProperties {
  constructor(data: QueryProperties) {
    Object.assign(this, data);
  }
  skippedRowsNbr: number;
  limitRowsNbr: number;
  isDuplicated: boolean;
  subQueryKind: SubQueryKind;
}

export class ColumnProperties {
  constructor(data: ColumnProperties) {
    Object.assign(this, data);
  }
  visible: boolean;
  sorting: QueryColumnSortOrder;
  spacing: ColumnSpacing;
  formatExpression: string;
  culture: boolean;
  filter: boolean;
}

export enum PropertiesViews {
  GENERAL_PROPERTIES = 'GENERAL_PROPERTIES',
  QUERY_PROPERTIES = 'QUERY_PROPERTIES',
  COLUMN_PROPERTIES = 'COLUMN_PROPERTIES',
}

export enum SelectionViews {
  SELECT_COLUMNS = 'SELECT_COLUMNS',
  SELECT_OBJECT_TYPE = 'SELECT_OBJECT_TYPE',
}

export enum ResultsViews {
  RESULTS_TABLE = 'RESULTS_TABLE',
  RESULTS_JSON = 'RESULTS_JSON',
  RESULTS_XML = 'RESULTS_XML',
  RESULTS_QUERY_XML = 'RESULTS_QUERY_XML',
  RESULTS_QUERY_JSON = 'RESULTS_QUERY_JSON',
}

export class ObjectSpaceInfo {
  name: string;
  value: string;
}

export enum SideBarButtonId {
  INSERT_QUERY = 0,
  INSERT_SUB_QUERY = 1,
  INSERT_COLUMNS = 2,
  INSERT_COLUMN = 3,
  DUPLICATE_COLUMN = 4,
  DELETE_COLUMN = 5,
  UP_WARDS = 6,
  DOWN_WARDS = 7,
  GROUPED_QUERY = 8,
  EXECUTE_AS_TABLE = 9,
  EXECUTE_AS_XML = 10,
  DISPLAY_AS_XML = 11,
  DISPLAY_AS_JSON = 12,
  RESET = 13,
}

export class Column {
  expression: string;
  name: string;
}

export class GridDataSource {
  id: string;
  alias: string;
  visible: boolean;
  expression: string;
  sorting: QueryColumnSortOrder;
  spacing: ColumnSpacing;
  culture: boolean;
  constructor(data: GridDataSource) {
    Object.assign(this, data);
  }
}

export enum ColumnSpacing {
  IGNOR_BLANK = 'Ignore blank elements',
  IGNOR_BLANK_PROPERTIES = 'Ignore blank elements and properties',
  CONSIDER_ELEMENT_PROPERRTIES = 'Constsider blank elements and properties',
}
export enum SideBarPosition {
  left = 'left',
  right = 'right',
}

export const UI_SETTINGS = {
  PROPERTIES_Min_WIDTH: 400,
  TREE_Min_WIDTH: 200,
  SELECTION_Min_WIDTH: 200,
  RESULT_MINHEIGHT: 280,
  RESULT_MAXHEIGHT: 498,
  RESULT_HEADER_HEIGHT: 40,
  HEADER_HEIGHT: 40,
  SPLITTER_MIN_TOLERENCE: 100,
};

export class SplitterConfig {
  maxWidth: number;
  minWidth: number;
  constructor(data: SplitterConfig) {
    Object.assign(this, data);
  }
}

export class TranslationConfiguration {
  menu: MenuTranslation;
  sideMenu: SideMenuTranslation;

  resultsTitle: string;
}

export class MenuTranslation {
  save: string;
  saveAndClose: string;
  executeAsTable: string;
  executeAsJSON: string;
  executeAsXML: string;
  showXMLQuery: string;
  showJSONQuery: string;
  resetTableLayout: string;
  reset: string;
  executeAutomatically: string;
}

export class SideMenuTranslation {
  insertQuery: string;
  insertSubQuery: string;
  insertColumns: string;
  insertColumn: string;
  duplicateColumn: string;
  deleteColumn: string;
  upwards: string;
  downwards: string;
}

export class GeneralPropertiesTranslation {
  title: string;
  nameOfRootElement: string;
  topic: string;
  confirmTopicChange: string;
}

export class QueryPropertiesTranslation {
  title: string;
  objectType: string;
  expression: string;
  alias: string;
  noDuplicates: string;
  skipNumberOfRows: string;
  limitNumberOfRows: string;
  gridTitle: string;
  gridColumnExpression: string;
  gridColumnAlias: string;
  gridColumnVisible: string;
  gridColumnSorting: string;
  subQueryKind: string;
  confirmObjectTypeChange: string;
}

export class ColumnPropertiesTranslation {
  title: string;
  expression: string;
  alias: string;
  visible: string;
  formatExpression: string;
  neutralCulture: string;
  sorting: string;
  emptyFields: string;
  filter: string;
}

export class ResultTranslation {
  tableResult: string;
  jsonResult: string;
  xmlResult: string;
  displayXmlQuery: string;
  displayJsonQuery: string;
  xmlPopUpMessage: string;
}

export class SelectObjectTypeTranslation {
  title: string;
  description: string;
  loadingMessage: string;
}

export class SelectColumsTranslation {
  title: string;
  keyColumnsDescription: string;
  systemColumnsDescription: string;
  neutralDesignation: string;
  ok: string;
  cancel: string;
}

export class QueriesEditorResult {
  queryDocumentId: string;
  objectSpaceName: string;
  rootElementName: string;
  objectQueries: Query[];
  parameterDefinitions: ParameterDefinition[];
}
